import { MFButton } from "../../../../common/components/MFButton";
import { MFCheckbox } from "../../../../common/components/MFCheckbox";
import MFModal from "../../../../common/containers/MFModal";

export function ModalGenerateBulkFiles({
  isOpen,
  onClose,
  onValidate,
  dontShowGenerateCalculsModal,
  setDontShowGenerateCalculsModal,
  selectedCalculs,
}) {
  const hasSimulationCalculs = selectedCalculs.some(
    (calcul) => calcul.simulationMode,
  );
  const hasOnlySimulationCalculs = selectedCalculs.every(
    (calcul) => calcul.simulationMode,
  );

  const hasOnlySimulationAndFinishedCalculs =
    !hasOnlySimulationCalculs &&
    selectedCalculs.every(
      (calcul) => calcul.simulationMode === true || calcul.isFinished === true,
    );

  const hasSimulationAndNotFinishedCalculs =
    hasSimulationCalculs &&
    !hasOnlySimulationCalculs &&
    !hasOnlySimulationAndFinishedCalculs;

  return (
    <MFModal
      isOpen={isOpen}
      onClose={onClose}
      dialogClassName="calculs-not-duplicable"
    >
      {hasOnlySimulationAndFinishedCalculs && (
        <p className="modal-text" style={{ marginBottom: "20px" }}>
          Certains calculs de votre lot sont des simulations. Après génération
          des exports, le statut de ces calculs restera à “En cours”. Vous
          pourrez télécharger les exports, et continuer de modifier les calculs
          pour générer si besoin d’autres exports (en mode simulation).
        </p>
      )}

      {hasSimulationAndNotFinishedCalculs && (
        <p className="modal-text" style={{ marginBottom: "20px" }}>
          Certains calculs de votre lot sont des simulations. Après génération
          des exports, le statut de ces calculs restera à “En cours”. Vous
          pourrez télécharger les exports, et continuer de modifier les calculs
          pour générer si besoin d’autres exports (en mode simulation).
          <br />
          <br />
          Pour les autres calculs de votre lot, leur statut passera à
          “Finalisé”. Vous ne pourrez plus modifier ou supprimer ces calculs.
          Vous pourrez par contre télécharger les exports, visualiser les
          calculs, les classer dans les dossiers ou encore les archiver.
        </p>
      )}

      {hasOnlySimulationCalculs && (
        <p className="modal-text" style={{ marginBottom: "20px" }}>
          Les calculs de votre lot sont des simulations. Après génération des
          exports, le statut de ces calculs restera à “En cours”. Vous pourrez
          télécharger les exports, et continuer de modifier les calculs pour
          générer si besoin d’autres exports (en mode simulation).
        </p>
      )}

      {!hasSimulationCalculs && (
        <p className="modal-text" style={{ marginBottom: "20px" }}>
          En générant les exports, le statut des calculs passera à “Finalisé”.
          Vous ne pourrez plus modifier ou supprimer ces calculs. Vous pourrez
          par contre télécharger les exports, visualiser les calculs, les
          classer dans les dossiers ou encore les archiver.
        </p>
      )}

      <div className="d-flex flex-column">
        <MFCheckbox
          checked={dontShowGenerateCalculsModal}
          onChange={(e) => setDontShowGenerateCalculsModal(e.target.checked)}
          label="Ne plus afficher ce message"
        />
      </div>
      <div className="d-flex align-items-center justify-content-end mt-2">
        <MFButton
          className="mr-1"
          style={{ fontSize: 15 }}
          cancelButton
          onClick={onClose}
        >
          Annuler
        </MFButton>
        <MFButton style={{ fontSize: 15 }} onClick={onValidate}>
          Valider
        </MFButton>
      </div>
    </MFModal>
  );
}
